import React from 'react';
import './App.scss';
import Routes from './components/routes'

const App = ()=> {

  return (
    <div className="App">
      <Routes/>
    </div>
  );
}

export default App;
